module.exports = __webpack_public_path__ + "img/1.efdf9ad4.jpg";